import React, { useState, useEffect } from "react";
import styles from "./PnS.module.css";
import Skeleton from "components/common/Skeleton";

const BASE = process.env.PUBLIC_URL + "/svg";
const solution1 = `${BASE}/solution1.svg`;
const solution2 = `${BASE}/solution2.svg`;
const solution3 = `${BASE}/solution3.svg`;
const problem1 = `${BASE}/problem1.svg`;
const problem2 = `${BASE}/problem2.svg`;
const problem3 = `${BASE}/problem3.svg`;

export default function PnS() {
    const [hoveredIdx, setHoveredIdx] = useState(null);
    const [selectedIdx, setSelectedIdx] = useState(null);
    const [showSolution, setShowSolution] = useState(false);
    const [isExiting, setIsExiting] = useState(false);
    const [resetKey, setResetKey] = useState(0);
    const [imagesLoaded, setImagesLoaded] = useState(false);

    const carousel = [
        {
            idx: 0,
            problem: {
                img: problem1,
                text1: "연락 안되는 차주 때문에 불편했던 경험!",
                text2: "빨리 가야하는데 어떡하지...",
            },
            solution: {
                img: solution1,
                text1: "비대면 채팅 기능",
                text2: "주차 정보를 공유할 수 있어요!",
            },
        },
        {
            idx: 1,
            problem: {
                img: problem2,
                text1: "주차 공간이 나올 때 까지 무한 기다림!",
                text2: "도대체 주차 자리는 언제 생기지...",
            },
            solution: {
                img: solution2,
                text1: "기다릴 필요 없이",
                text2: "출차 시간도 미리 알 수 있어요!",
            },
        },
        {
            idx: 2,
            problem: {
                img: problem3,
                text1: "기대 했던 맛집의 주차 공간 부족",
                text2: "주변에 주차할 곳도 없는데..",
            },
            solution: {
                img: solution3,
                text1: "어느 장소든 주차장 먼저",
                text2: "마음 편하게 주차 할 수 있어요!",
            },
        },
    ];

    // 문제/해결 이미지 모두 로딩 끝나야 화면 보여주기
    useEffect(() => {
        const imgs = [
            problem1, problem2, problem3,
            solution1, solution2, solution3
        ];
        let loadedCount = 0;

        imgs.forEach((src) => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                loadedCount++;
                if (loadedCount === imgs.length) {
                    setImagesLoaded(true);
                }
            };
        });
    }, []);

    // 선택 시 → 2초 뒤 solution → 4.7초 뒤 fade-out 시작 → 5초 뒤 reset
    useEffect(() => {
        if (selectedIdx !== null) {
            const toSolution = setTimeout(() => setShowSolution(true), 2000);
            const toExit   = setTimeout(() => setIsExiting(true), 4700);
            const toReset  = setTimeout(() => {
                setShowSolution(false);
                setSelectedIdx(null);
                setIsExiting(false);
                setResetKey((k) => k + 1);
            }, 5000);
            return () => {
                clearTimeout(toSolution);
                clearTimeout(toExit);
                clearTimeout(toReset);
            };
        }
    }, [selectedIdx]);

    const handleClick = (idx) => {
        if (selectedIdx !== null) return;
        setSelectedIdx(idx);
        setShowSolution(false);
    };

    // ⛔ 아직 이미지 안 불러왔으면 Skeleton만 보여주기
    if (!imagesLoaded) {
        return <Skeleton height="500px" />;
    }

    return (
        <div className={styles.PnS}>
            {carousel.map((item) => {
                if (selectedIdx !== null && selectedIdx !== item.idx) return null;

                const isHovered = hoveredIdx === item.idx;
                const isSelected = selectedIdx === item.idx;
                const content = showSolution ? item.solution : item.problem;

                return (
                    <div
                        key={`${item.idx}-${resetKey}`}
                        className={`${styles.card}
                          ${isHovered && !isSelected ? styles.hovered : ""}
                          ${isSelected ? styles.selected : ""}
                          ${isSelected && isExiting ? styles.exiting : ""}
                          ${showSolution ? styles.solutionLayout : styles.problemLayout}`}
                        onMouseEnter={() => {
                            if (selectedIdx === null) setHoveredIdx(item.idx);
                        }}
                        onMouseLeave={() => {
                            if (selectedIdx === null) setHoveredIdx(null);
                        }}
                        onClick={() => handleClick(item.idx)}
                    >
                        <div className={styles.imgBox}>
                            <img src={content.img} alt="problem/solution" />
                        </div>
                        {isSelected && (
                            <div className={styles.textBox}>
                                <div className={styles.text6}>{content.text1}</div>
                                <div className={styles.text7}>{content.text2}</div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
